<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Tax Rates</span>
      </b-col>
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <b-button variant="primary" size="sm" @click="gettaxratemodal()">New TaxRate</b-button>

        <b-button variant="primary" size="sm" class="ml-2" @click="gettaxgroupmodal()">New TaxGroup</b-button>
      </b-col>
    </b-row>
    <!-- Table for details -->
    <b-row>
      <b-col cols="12" class="px-0">
        <div class="table-responsive px-0">
          <table class="table table-hover not-fixed-col not-fixed-last-col index-table">
            <thead>
              <tr>
                <th style="padding-left: 1.6rem !important;width:250px !important">Tax Name</th>
                <th class="text-left" style="width:150px !important">Tax Type</th>
                <th class="text-right" style="width:150px !important">Rate (%)</th>
                <th
                  class="text-right"
                  style="width:30px !important;padding-right: 1.6rem !important;"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in lists" :key="item.id">
                <td style="width:250px !important;padding-left: 1.6rem !important;">
                  <span class="text pr-3">{{ item.tax_name }}</span>
                </td>
                <td class="text-left">{{ item.tax_type }}</td>
                <td class="text-right">{{ item.tax_percent }}</td>
                <td class="text-right" style="padding-right: 1.6rem !important;">
                  <b-dropdown
                    right
                    toggle-class="text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    class="table-hover-visible last-td-arrow"
                    v-if="item.tax_type_id != 3 || item.tax_default != 1"
                  >
                    <template slot="button-content">
                      <i
                        class="glyphicon glyphicon-option-vertical theme-text-color"
                        style="top:-6px !important;letter-spacing:-5px !important"
                      ></i>
                    </template>
                    <span
                      v-if="item.tax_type_id != 3 || item.tax_default != 1"
                      class="event-link dropdown-item"
                      @click="item.is_group == 1 ? getupdatetaxgroupmodal(index) : getupdatetaxratemodal(index)"
                    >Edit</span>
                    <span
                      @click="indexid = index"
                      v-if="item.tax_type_id != 3 || item.tax_default != 1"
                      class="event-link dropdown-item"
                      v-b-modal="item.is_group == 1 ? 'taxgroupdelete' : 'taxratedelete'"
                    >Delete</span>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <TaxRate
      :page="page"
      v-on:updateTaxpage="triggertaxpage"
      :detailupdate="detailupdate"
      :list="list"
    ></TaxRate>
    <TaxGroupForm
      :page="page"
      v-on:updateTaxpage="triggertaxpage"
      :detailupdate="detailupdate"
      :list="list"
    ></TaxGroupForm>
    <!--  bulk delete modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="taxgroupdelete"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
      @ok="deletetaxgroup(indexid)"
      title="Delete Tax Group"
      ref="delete"
      :ok-disabled="submitted"
    >
      <p>Are you sure about deleting selected tax group?</p>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="taxratedelete"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
      @ok="deletetaxrate(indexid)"
      title="Delete Tax Rate"
      ref="delete"
      :ok-disabled="submitted"
    >
      <p>Are you sure about deleting selected tax rate?</p>
    </b-modal>
    <LogRecord :message="logrecords"></LogRecord>
  </div>
</template>
<script>
// import all the components, files and funciton
import { mapState } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import TaxRate from "@/components/Form/Settings/TaxGroup/TaxRateForm";
import TaxGroupForm from "@/components/Form/Settings/TaxGroup/TaxGroupForm";
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created tax rates used record
//pages
function getPageTaxes(routeTo, next) {
  store.dispatch("taxgroup/fetchLists").then(() => {
    next();
  });
}
export default {
  mixins: [notificationMixin], //call the global mixin function
  name: "TaxGroup",
  data() {
    return {
      indexid: "",
      page: "",
      detailupdate: false,
      list: "",
      logrecords: "", // to show log of popup funcitons
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false
    };
  },
  components: {
    LogRecord,
    TaxRate,
    TaxGroupForm
  },
  methods: {
    async triggertaxpage() {
      this.detailupdate = await false;
      this.list = "";
      await this.$store.dispatch("taxgroup/fetchLists");
    },
    async gettaxratemodal() {
      if (this.detailupdate == false) {
        await this.$store.dispatch("taxgroup/fetchDetails");
        this.detailupdate = true;
      }
      this.page = await "create";
      await this.$root.$emit("bv::show::modal", "taxrate");
    },

    async gettaxgroupmodal() {
      if (this.detailupdate == false) {
        await this.$store.dispatch("taxgroup/fetchDetails");
        this.detailupdate = true;
      }
      this.page = await "create";
      await this.$root.$emit("bv::show::modal", "taxgroup");
    },
    async getupdatetaxratemodal(index) {
      this.list = await this.lists[index];
      if (this.detailupdate == false) {
        await this.$store.dispatch("taxgroup/fetchDetails");
        this.detailupdate = true;
      }
      this.page = await "update";
      await this.$root.$emit("bv::show::modal", "taxrate");
    },

    async getupdatetaxgroupmodal(index) {
      this.list = await this.lists[index];
      if (this.detailupdate == false) {
        await this.$store.dispatch("taxgroup/fetchDetails");
        this.detailupdate = true;
      }
      this.page = await "update";
      await this.$root.$emit("bv::show::modal", "taxgroup");
    },
    async deletetaxrate(index) {
      this.submitted = true;
      await this.$store.dispatch(
        "taxgroup/deletetaxrate",
        JSON.stringify({
          id: this.lists[index].tax_id
        })
      );
      this.submitted = false;
      this.logrecords =
        this.message.message.length == 0
          ? this.message.success
          : this.message.message;
      this.$root.$emit("bv::show::modal", "loglist");
      await this.triggertaxpage();
    },
    async deletetaxgroup(index) {
      this.submitted = true;
      await this.$store.dispatch(
        "taxgroup/deletetaxgroup",
        JSON.stringify({
          id: this.lists[index].tax_id
        })
      );
      this.submitted = false;
      this.logrecords =
        this.message.message.length == 0
          ? this.message.success
          : this.message.message;
      this.$root.$emit("bv::show::modal", "loglist");
      await this.triggertaxpage();
    }
  },

  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageTaxes(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageTaxes(routeTo, next);
  },
  //computed properties
  computed: {
    ...mapState({
      message: state => state.taxgroup.log_details,
      lists: state => state.taxgroup.lists
    })
  }
};
</script>